"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldHelpText = exports.FieldFeedbackText = exports.Field = void 0;
var react_1 = __importDefault(require("react"));
var Feedback_1 = require("./Feedback");
var distillUtilityClasses_1 = __importDefault(require("../../utility/distillUtilityClasses"));
var Label_1 = require("./Label");
exports.Field = function (props) {
    var inline = props.inline, grid = props.grid, stacked = props.stacked, fill = props.fill, auto = props.auto, feedback = props.feedback, label = props.label, helpText = props.helpText, feedbackText = props.feedbackText, _a = props.component, Component = _a === void 0 ? "div" : _a, className = props.className, children = props.children, utilityAndDivProps = __rest(props, ["inline", "grid", "stacked", "fill", "auto", "feedback", "label", "helpText", "feedbackText", "component", "className", "children"]);
    var _b = distillUtilityClasses_1.default(utilityAndDivProps), utilityProps = _b[0], divProps = _b[1];
    var classes = __spreadArrays([
        "c-field",
        inline ? "+inline" : "",
        grid ? "+grid" : "",
        stacked ? "+stacked" : "",
        fill ? "+fill" : "",
        auto ? "+auto" : "",
        feedback
    ], utilityProps, [
        className,
    ]).filter(function (item) { return !!item; });
    return (react_1.default.createElement(Component, __assign({ className: classes.join(" ") }, divProps),
        label && react_1.default.createElement(Label_1.Label, null, label),
        helpText && react_1.default.createElement(exports.Field.HelpText, null, helpText),
        children,
        feedbackText && react_1.default.createElement(exports.Field.FeedbackText, null, feedbackText)));
};
exports.Field.displayName = "Field";
exports.FieldFeedbackText = function (props) {
    var _a = props.component, Component = _a === void 0 ? "span" : _a, className = props.className, utilityAndSpanProps = __rest(props, ["component", "className"]);
    var _b = distillUtilityClasses_1.default(utilityAndSpanProps), utilityProps = _b[0], spanProps = _b[1];
    var classes = __spreadArrays(["c-field__feedback"], utilityProps, [className]);
    return react_1.default.createElement(Component, __assign({ className: classes.join(" ") }, spanProps));
};
exports.FieldFeedbackText.displayName = "FieldFeedback";
exports.FieldHelpText = function (props) {
    var _a = props.component, Component = _a === void 0 ? "span" : _a, className = props.className, utilityAndSpanProps = __rest(props, ["component", "className"]);
    var _b = distillUtilityClasses_1.default(utilityAndSpanProps), utilityProps = _b[0], spanProps = _b[1];
    var classes = __spreadArrays(["c-field__help-text"], utilityProps, [className]);
    return react_1.default.createElement(Component, __assign({ className: classes.join(" ") }, spanProps));
};
exports.Field.Feedback = Feedback_1.Feedback;
exports.Field.FeedbackText = exports.FieldFeedbackText;
exports.Field.HelpText = exports.FieldHelpText;
//# sourceMappingURL=Field.js.map